import { FindifyDataContextType } from "@/contexts/FindifyDataContext";
import { getApiFromModule } from "./GetContentsByModule";

export const loadApiData = (setLoadedInitialData: (loaded: boolean) => void, findifyDataContext: FindifyDataContextType | null) => {
    if (!findifyDataContext) {
        setLoadedInitialData(true);
        return;
    }

    const publicWorkspacesApi = getApiFromModule('workspaces', findifyDataContext);
    if (!publicWorkspacesApi) {
        setLoadedInitialData(true);
        return;
    }

    publicWorkspacesApi.getList(0, 1, null, null, null).then((data: any) => {
        // Handle case where data might be a list or a single object
        const workspaceData = data?.results ? data.results[0] : data;
        
        if (workspaceData) {
            findifyDataContext.setWorkspace(workspaceData);
            
            // If selected language is invalid, set it to first workspace language
            if (workspaceData.languages && workspaceData.languages.length > 0) {
                const validLang = workspaceData.languages.find((lang: any) => lang?.language?.tag === findifyDataContext.language);
                if (!validLang) {
                    findifyDataContext.setLanguage(workspaceData.languages[0]?.language?.tag);
                }
            }
        }
        setLoadedInitialData(true);
    }).catch((err: any) => {
        console.error("Failed to load API data:", err);
        setLoadedInitialData(true); // Still set to true to avoid infinite loading screen
    });
}
